const defaults = {
    modalTitle: 'Search Products',
    modalSubtitle: 'Find products by name, SKU, tags, or usage',
    closeSearch: 'Close search',
    searchLabel: 'Search products',
    placeholder: 'Search products...',
    loadingIndex: 'Loading search index...',
    errorTitle: 'Error loading search index',
    startTyping: 'Start typing to search',
    startTypingDesc: 'Search by product name, SKU, tags, or usage',
    noResultsFor: 'No results found for "%s"',
    noResultsTip: 'Try different keywords or check spelling',
    shortQueryHint: 'Type at least 3 characters to narrow down the search results.',
    suggestions: 'Suggestions:',
    searchTips: 'Search tips:',
    tipBroader: 'Use broader terms',
    tipSku: 'Check product SKU',
    tipCategory: 'Try category names',
    tipFilters: 'Remove filters',
    footerNavigate: 'Navigate',
    footerOpen: 'Open',
    footerClose: 'Close',
    resultSingular: 'result',
    resultPlural: 'results',
    openSearchLabel: 'Open search',
    clearSearch: 'Clear search',
    searchButton: 'Search',
    includeBStock: 'Include B-Stock items',
};
export function getI18n() {
    const fromConfig = window.enoSearchConfig?.i18n;
    if (!fromConfig)
        return defaults;
    return { ...defaults, ...fromConfig };
}
